module.exports = __webpack_public_path__ + "static/media/thumbnail_ally-ups-drape@2x.1e79e763.jpg";